import Vue from 'vue';

const success = (context, response, fromCalendar) => {
  if (!fromCalendar) {
    context.bookingsCheckings = response.data.checking;
    context.bookingsCheckouts = response.data.checkout;
    context.teamMembers = response.data.members;
    context.rentals = response.data.rentals;

    context.statusCounts = {
      toBeAssigned: 0,
      assigned: 0,
      done: 0,
      cleaningFast: 0,
      cancelled: 0
    };
    context.calculateCounts();
  } else {
    context.membersForChecking = response.data.members;
    context.membersForCheckout = response.data.members;
  }
};

const failed = (error) => {
    toastr.error('Booking not found');
};

export default (context, selectedDay, rentalIds, fromCalendar = false) => {
 return Vue.$http.get(`bookings/get-by-selected-day/${selectedDay}?rentalIds=${rentalIds}`).
     then(response => {
         if(response && response.status === 200) {
           success(context, response, fromCalendar);
         }
      }).catch(error => {
        failed(error);
      })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/getBookingsSelectedDay.js